import { render } from "./LoadingButton.vue?vue&type=template&id=104c586b&scoped=true"
import script from "./LoadingButton.js?vue&type=script&lang=js"
export * from "./LoadingButton.js?vue&type=script&lang=js"

import "./LoadingButton.scss?vue&type=style&index=0&id=104c586b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104c586b"]])

export default __exports__